import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { authentication } from "../configs";

function useFirebaseUser() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(authentication, (firebaseUser) => {
      setUser(firebaseUser ?? null);
    });
    return () => unsubscribe();
  }, []);

  return user;
}

export default useFirebaseUser;
